"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../core/conversions/DataObjectConverter");
/**
 * KPI Record converter.
 *
 * @author Stepan Mik
 */


var KpiRecordConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(KpiRecordConverter, _DataObjectConverter_);

  function KpiRecordConverter() {
    _classCallCheck(this, KpiRecordConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(KpiRecordConverter).apply(this, arguments));
  }

  return KpiRecordConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.KpiRecordConverter = KpiRecordConverter;